var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 234,
    height: 62,
    viewBox: "0 0 234 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0C0 0 29.3766 25.1351 117 25.1351C204.623 25.1351 234 0 234 0V42C234 53.0457 225.046 62 214 62H20C8.9543 62 0 53.0457 0 42V0Z",
    fill: "url(#paint0_linear_694_213)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_694_213",
    x1: 116.494,
    y1: 24.7162,
    x2: 116.84,
    y2: 62.0015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDCC05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE788"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteBottom);
export default __webpack_public_path__ + "static/media/white-bottom.828bcc9d69a98e1e8565724202048040.svg";
export { ForwardRef as ReactComponent };